module.exports = __webpack_public_path__ + "img/clint.f02500ce.png";